import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { FieldsetModule } from 'primeng/fieldset';
import { Subscription } from 'rxjs';
import { LookupService } from 'src/app/services/lookup.service';
import { UserService } from 'src/app/services/user.service';
import { ListService } from 'src/app/shared/services/list.service';

@Component({
    selector: 'ppl-purchase-request-edit-history',
    templateUrl: './purchase-request-edit-history.component.html',
    styleUrls: ['./purchase-request-edit-history.component.css'],
    standalone: true,
    imports: [
        TableModule,
        FieldsetModule
    ],
})
export class PurchaseRequestEditHistoryComponent implements OnInit, OnDestroy {
    @Input() purchaseRequestLineId!: any;
    purchaseRequestEditHistoryData: any[] = [];
    private programName!: string;
    private listDataSub!: Subscription;
    groupedPurchaseRequestEditHistoryData: any[] = [];
    dispositionReason: any[] = [];
    purchaseRequestDisposition: any[] = [];

    constructor(
        private listService: ListService,
        private userService: UserService,
        private lookupService: LookupService
    ) { }

    ngOnInit(): void {
        const selectedProgram = this.userService.getSelectedProgram();
        this.dispositionReason = this.lookupService.getLookupValue('Disposition Reason');
        this.purchaseRequestDisposition = this.lookupService.getLookupValue('TimeSheet Disposition');
        this.programName = selectedProgram?.program_code ?? '';
        this.getPurchaseRequestEditHistory();
    }

    getPurchaseRequestEditHistory() {
        if (!this.purchaseRequestLineId) {
            return;
        }

        const payload: any = {
            pageName: 'purchaserequest-processCode-history',
            programCode: this.programName,
            condition: 'and',
            recordsPerPage: 20,
            startingPageNumber: 1,
            searchParam: [
                {
                    jsonPath: 'purchaserequestId',
                    value: this.purchaseRequestLineId,
                    operator: 'Equal',
                },
            ],
            orderByColumn: [],
            orderBy: ['desc'],
        };

        this.listDataSub = this.listService.getListData(payload, 'claims').subscribe(data => {
            const responseData = data?.responsedata;
            this.purchaseRequestEditHistoryData = responseData || [];
            this.purchaseRequestEditHistoryData.forEach((e: any) => {
                if (e.reasonLkp) {
                    e.reason = this.dispositionReason.filter((d: any) => d.lkpValueCode == e.reasonLkp)[0].lkpValueName;
                }

                if (e.dispositionLkp) {
                    e.disposition = this.purchaseRequestDisposition.filter((d: any) => d.lkpValueCode == e.dispositionLkp)[0].lkpValueName
                }
            });
            this.groupByRunDate();
        });
    }

    groupByRunDate() {
        const groupedByRunDate = this.purchaseRequestEditHistoryData.reduce((acc, item) => {
            const key = item.runDate ?? null;
            if (!acc[key]) {
                acc[key] = { runDate: item.runDate, items: [] as any[] };
            }
            acc[key].items.push(item);
            return acc;
        }, {} as Record<string, { runDate: string; items: any[] }>);

        const groupedArray = Object.values(groupedByRunDate);
        this.groupedPurchaseRequestEditHistoryData = groupedArray;
    }

    ngOnDestroy(): void {
        if (this.listDataSub) {
            this.listDataSub.unsubscribe();
        }
    }
}
